var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continer"},[_c('div',{staticClass:"center"},[_c('h1',[_vm._v("通辽大地建设工程施工图审查有限责任公司")])])])}]

export { render, staticRenderFns }